import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import AttachmentUploader, { FILE_TYPE } from '@src/js/common/ark-extensions/dc-components/attachment-uploader';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { config } from './config';
import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

@Feature()
export class InsertUploadLocalFileFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    public onClick() {
        const uploadLocalFileNoLimit = getCacConfigByKey('custom.toolbarFileMenu.uploadLocalFileNoLimit', false);
        if (uploadLocalFileNoLimit) {
            AttachmentUploader.getInstance().upload();
        } else {
            AttachmentUploader.getInstance().upload({ acceptFileType: FILE_TYPE });
        }
        try {
            this.twdReport();
        } catch (e) {
            console.log('upload twd error');
        }
    }

    protected getCustomDisabledState(): boolean {
        const shouldDisableInMaster = this.shouldDisableInMaster(config.id);
        // 本地编辑需要额外判断功能是否可用
        if (ENV.IS_PC_LOCAL_EDIT) {
            return shouldDisableInMaster || !AttachmentUploader.getInstance().hasInit;
        }
        return shouldDisableInMaster;
    }
}
